import React from "react";
import { Spin, Divider, Row, Col, Card, Statistic, Space } from "antd";
import { InfoCircleOutlined, FileTextOutlined } from "@ant-design/icons";

const CustomerSummary = ({ customerSummary, loadingCustomerSummary }) => {
  if (loadingCustomerSummary) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        <Spin />
        <div style={{ marginTop: "16px", color: "#999" }}>
          Loading customer invoice history...
        </div>
      </div>
    );
  }

  if (
    !customerSummary ||
    ((!customerSummary.invoices || customerSummary.invoices.length === 0) &&
      (!customerSummary.invoice_summary || customerSummary.invoice_summary.length === 0))
  ) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        <InfoCircleOutlined style={{ fontSize: "48px", color: "#999", marginBottom: "16px" }} />
        <div style={{ fontSize: "16px", color: "#666", marginBottom: "8px" }}>
          No order history found
        </div>
        <div style={{ fontSize: "14px", color: "#999" }}>
          This customer has not placed any orders yet.
        </div>
      </div>
    );
  }

  const { invoices = [], invoice_summary = [] } = customerSummary;

  const hasNoOrders =
    invoice_summary.every((item) => item.count === 0) && invoices.length === 0;

  if (hasNoOrders) {
    return (
      <div style={{ textAlign: "center", padding: "40px" }}>
        <InfoCircleOutlined style={{ fontSize: "48px", color: "#999", marginBottom: "16px" }} />
        <div style={{ fontSize: "16px", color: "#666", marginBottom: "8px" }}>
          No order history found
        </div>
        <div style={{ fontSize: "14px", color: "#999" }}>
          This customer has not placed any orders yet.
        </div>
      </div>
    );
  }

  return (
    <Spin spinning={loadingCustomerSummary}>
      <Divider orientation="left">Invoice Summary</Divider>
      <Row gutter={16} style={{ marginBottom: 24 }}>
        {invoice_summary.map((summary, index) => (
          <Col span={8} key={index}>
            <Card size="small">
              <Statistic
                title={
                  <Space>
                    <FileTextOutlined />
                    {summary.status}
                  </Space>
                }
                value={summary.count}
                suffix="invoices"
                valueStyle={{
                  color:
                    summary.status === "Delivered"
                      ? "#1677ff"
                      : summary.status === "Pending"
                      ? "#745517ff"
                      : summary.status === "Exchanged"
                      ? "#023f05ff"
                      : summary.status === "Cancelled"
                      ? "#85010cff"
                      : "#000",
                  fontSize: "20px",
                }}
              />
              <Divider style={{ margin: "8px 0" }} />
            </Card>
          </Col>
        ))}
      </Row>
    </Spin>
  );
};

export default CustomerSummary;